module.exports = __webpack_public_path__ + "static/media/TenaliRamakrishna-Regular.3f0d04a2.ttf";